import common from './common'

//入力保持
function identifyItem(obj) {
    let sd = new Date(common.getStore(obj, 'specificDate'))
    let now = new Date()
    // 毎年12月にリネット様から年末年始の休みを聞いて、年末年始休みの最終日を設定する。
    // 将来的には年末年始休みをマスタで管理し、マスタの設定で制御する予定
    let limitDate = new Date(2024, 0, 5, 0, 0, 0)

    obj.msgDispFlg = limitDate.getTime() - now.getTime() > 0
    obj.itemsDataTax = common.getStore(obj, 'itemsDataTax')
    obj.largeItems = common.getStore(obj, 'largeItems')
    obj.specificDate = common.getStore(obj, 'specificDate')
    obj.specificDay = '（' + common.constant.DAY_STR_ARRSY[sd.getDay()].name + '）'
    obj.specificTime = common.getStore(obj, 'specificTime')

    // 大型情報の表示フラグ
    obj.largeFlg = Boolean(obj.itemsDataTax.large_items.length)
    // 中小型情報の表示フラグ
    obj.mediumSmallFlg = Boolean(obj.itemsDataTax.mediumSmallQuantity)
    // データ消去関連項目の表示フラグ
    obj.erasePcFlg = common.getStore(obj, 'erasePcNum') > 0
}

//申込書印刷ボタン押下
function printApplicationForm(obj) {

  let applicationFormParams = {
    "applyId": obj.itemsDataTax.apply_id
    , "erasePcNum": obj.erasePcNum
  }

  // 別タブで申込書を開く
  window.open(common.constant.BASE_PATH + common.constant.DATA_ERASE_APPLICATION_FORM_PATH + '?applicationFormParams=' + encodeURIComponent(JSON.stringify(applicationFormParams)))
}

export default {
    common,
    identifyItem,
    printApplicationForm
}
